import { usersHandler } from './users.handler'
import { authHandler } from './auth.handler'
import { eventsHandler } from './events.handler'

const handlers = [...usersHandler, ...authHandler, ...eventsHandler]

export default handlers
